import r from "./ghl-ui.es1409.js";
import i from "./ghl-ui.es1410.js";
function f(t, a) {
  var e = i(t, a);
  return r(e) ? e : void 0;
}
export {
  f as default
};
